import { Col, Row } from "react-bootstrap";
import { Product } from "models/Product";
import trashImg from '../../images/trash.png';
import { useCart } from "contexts/CartProvider";
import QuantityPicker from "components/Shared/QuantityPicker";
import { useState } from "react";
import ProductPrice from '../Shared/ProductPrice';
import { FormattedMessage, useIntl } from "react-intl";
import { setGA4EcommerceEvent } from "models/config";
import { useSiteConfig } from 'contexts/SiteConfigProvider';

const ProductItem = ({ product }: { product: Product }) => {
  const { removeFromCart, updateItem } = useCart(),
    [quantity, setQuantity] = useState(product.quantity);
  const minQty = 0, maxQty = 99;
  const handleDeleteBtnClick = () => {
    removeFromCart(product);
    trackCartChangedEvent(0);
  };
  const quantityChange = (e: any) => {
    const re = /^[0-9\b]+$/;
    if (e.target.value && re.test(e.target.value)) {

      setProductQuantity(parseInt(e.target.value));
    } else {
      setProductQuantity(0);
    }
  };
  const setProductQuantity = (qty: number) => {
    console.log(qty);
    if (qty > maxQty) qty = maxQty;
    if (qty < minQty) qty = minQty;
    console.log(`Going to set number to ${qty}`);
    trackCartChangedEvent(qty);
    setQuantity(qty);
    updateItem(product, qty);
  };

  const { getCurrencyCode } = useSiteConfig();
  const trackCartChangedEvent = (newQty: number) => {
    const eventName = newQty > quantity ? 'add_to_cart' : 'remove_from_cart',
      qtyChanged = newQty > quantity ? (newQty - quantity) : (quantity - newQty),
      ecommerce = {
        currency: getCurrencyCode(),
        value: product.optimizedPrice ? (qtyChanged * product.optimizedPrice) : 0,
        items: [{
          item_id: product.materialNumberTrimmed,
          item_name: product.materialLongDescription,
          price: product.optimizedPrice,
          quantity: qtyChanged,
          currency: getCurrencyCode()
        }]
      };
    setGA4EcommerceEvent(eventName, ecommerce);
  };
  const intl = useIntl();
  return <>
    <Row className="product-item">
      <Col md={2} className="my-auto">
        <img src={`${import.meta.env.VITE_ONLINE_SHOP_BASE_URL}/images/products/${product.image}`} className="product-img-small" alt={product.materialDescription}></img>
      </Col>
      <Col md={3} className="my-auto">
        <Row>{product.materialLongDescription}</Row>
        <Row><FormattedMessage id="ml_114872" defaultMessage="X - AP Product Number" /> {product.materialNumberTrimmed}</Row>
      </Col>
      <Col md={2} className="my-auto"><ProductPrice price={product.optimizedPrice} /></Col>
      <Col md={2} className="my-auto">
        <QuantityPicker quantity={quantity}
          minusClickHandler={() => setProductQuantity(parseInt(quantity.toString()) - 1)}
          plusClickHandler={() => setProductQuantity(parseInt(quantity.toString()) + 1)}
          onChangeHandler={quantityChange} label={intl.formatMessage({ id: 'ml_114614', defaultMessage: 'Quantity' })}></QuantityPicker>
      </Col>
      <Col md={2} className="my-auto"><ProductPrice price={product.optimizedPrice} quantity={quantity} /></Col>
      <Col md={1} className="my-auto"><img className="product-delete-btn" src={trashImg} onClick={handleDeleteBtnClick} alt={intl.formatMessage({ id: 'ml_153094', defaultMessage: 'Delete Item' })}></img></Col>
    </Row>
  </>;
};


export default ProductItem;